import Api from "./Api";
import { debugLog } from "../../utils/debug";

export async function authenticateUser(email, password) {
    const requestData = {
        email: email,
        password: password,
    };

    try {
        const res = await Api.post(`/user/authenticate`, requestData);
        const customerData = res.data;
        sessionStorage.setItem("customer", JSON.stringify(customerData));
        return true;
    } catch (error) {
        debugLog("Received an error from API when logging in: " + (error.response?.status || error.message));
        return false;
    }
}

export async function refreshAuthenticatedUser() {
    try {
        const res = await Api.post(`/user/refresh-token`);
        const customerData = res.data;
        sessionStorage.setItem("customer", JSON.stringify(customerData));
        return customerData;
    } catch (error) {
        debugLog("Received an error from API when refreshing token: " + (error.response?.status || error.message));
        return null;
    }
}
